export default "__VITE_ASSET__DPNfAtso__"